import { Box } from '@mui/material';
import { Flex, FlexCol } from '@/UI/styles';
import { EL_COLORS } from '@/colors';
import { useKlingElementView } from '../../Recipe/FlowContext';
import { ImageFileViewer } from '../Shared/FileViewer';
import { DynamicNode2 } from '../DynamicNode/DynamicNode2';
import { getNodeIcon } from '../utils/NodeIcon';
import type { NodeId, InputId } from 'web';
import type { KlingElementData } from '@/types/node';

function KlingImagePreview({
  inputId,
  nodeId,
  aspectRatio = 1,
}: {
  inputId: InputId;
  nodeId: NodeId;
  aspectRatio?: number;
}) {
  const view = useKlingElementView(nodeId);
  const image = view.evaluateImageInput(inputId);

  if (!image) {
    return (
      <Box sx={{ borderRadius: 2, border: `1px solid ${EL_COLORS.BoxBorder}` }}>
        <Box
          className="media-container-dark"
          sx={{
            aspectRatio,
            borderRadius: 2,
          }}
        />
      </Box>
    );
  }
  return <ImageFileViewer url={image.url} width={image.width} height={image.height} />;
}

interface KlingElementNodeProps {
  id: NodeId;
  data: KlingElementData;
}

export const KlingElementNode = ({ id, data }: KlingElementNodeProps) => {
  return (
    <DynamicNode2 id={id} data={data} icon={getNodeIcon({ name: 'kling' })}>
      <FlexCol sx={{ gap: 1, width: '100%' }}>
        <KlingImagePreview inputId="frontal_image_url" nodeId={id} aspectRatio={1.48} />
        <Flex sx={{ gap: 1, width: '100%' }}>
          {(['reference_image_url1', 'reference_image_url2', 'reference_image_url3'] as InputId[]).map((inputId) => (
            <Box key={inputId} sx={{ flex: 1 }}>
              <KlingImagePreview inputId={inputId} nodeId={id} />
            </Box>
          ))}
        </Flex>
      </FlexCol>
    </DynamicNode2>
  );
};
